<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  [attr.aria-labelledby]="'label.selectMenu.title' | staticMsg"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <!-- モーダルヘッダーが入ります -->
    <div class="p-modal-head02">
      <h1
        id="modalTitle2"
        class="p-modal-head02__title p-modal-head02__title--blue"
        [innerHTML]="'label.selectMenu.title' | staticMsg"
      ></h1>
      <button class="p-modal-head02__close js-wModal-close" (click)="clickClose()" id="close-modal-select-menu">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal'"></span>
      </button>
    </div>
    <!-- //モーダルヘッダーが入ります -->
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <!-- モーダルの中身が入ります -->
    <div class="p-modal-menu02">
      <div class="p-modal-menu02__title">
        <h2 class="p-modal-menu02__title-label" [innerHTML]="'label.normalMeal' | staticMsg"></h2>
        <ul class="c-inline-list01">
          <li class="c-inline-list01__item" [innerHTML]="normalInFlightMealMenuDetailsLabel | staticMsg"></li>
        </ul>
      </div>
      <ng-container *ngIf="isDisplayPaidMealInformation">
        <div class="p-modal-menu02__title">
          <h2 class="p-modal-menu02__title-label" [innerHTML]="'label.chargeableMeal' | staticMsg"></h2>
          <ul class="c-inline-list01">
            <li class="c-inline-list01__item" [innerHTML]="'label.mealMenuDetail.chargeable' | staticMsg"></li>
            <li class="c-inline-list01__item" [innerHTML]="'label.ruleDetail.meal.chargeable' | staticMsg"></li>
          </ul>
        </div>

        <ul class="p-modal-menu02__list">
          <ng-container *ngFor="let displayedMeal of displayedPaidMealList">
            <ng-container
              *ngIf="displayedMeal.isActive && isDisplaySoldOut(displayedMeal.quota ?? 0) !== true; else inActive"
            >
              <li class="p-modal-menu02__list-item">
                <button
                  type="button"
                  class="p-modal-menu02__btn p-modal-menu02__btn--arrow"
                  id="paid-exclusive-dining-meal-01"
                  (click)="handleMealMenu(displayedMeal)"
                >
                  <span class="p-modal-menu02__btn-inner">
                    <span class="p-modal-menu02__btn-label">{{ displayedMeal.mealName }}</span>
                    <span class="p-modal-menu02__btn-status p-modal-menu02__btn-status--em">
                      <span class="c-amount c-amount--price">
                        <span class="c-amount__num c-amount__num--fs20">
                          {{
                            displayedMeal?.prices?.total ?? 0
                              | amountFormat : undefined : displayedMeal?.prices?.currencyCode
                          }}
                        </span>
                      </span>
                    </span>
                  </span>
                </button>
              </li>
            </ng-container>
            <ng-template #inActive>
              <li class="p-modal-menu02__list-item">
                <div class="p-modal-menu02__list-text">
                  <div class="p-modal-menu02__list-text-inner">
                    <span class="p-modal-menu02__btn-label">{{ displayedMeal.mealName }}</span>
                    <span
                      *ngIf="isDisplaySoldOut(displayedMeal.quota ?? 0) !== true; else soldOut"
                      class="p-modal-menu02__btn-status p-modal-menu02__btn-status--em"
                    >
                      <span class="c-amount c-amount--price">
                        <span class="c-amount__num c-amount__num--fs20">
                          {{
                            displayedMeal?.prices?.total ?? 0
                              | amountFormat : undefined : displayedMeal?.prices?.currencyCode
                          }}
                        </span>
                      </span>
                    </span>
                    <ng-template #soldOut>
                      <span class="p-modal-menu02__btn-status" [innerHTML]="'label.soldOut' | staticMsg"></span>
                    </ng-template>
                  </div>
                </div>
              </li>
            </ng-template>
          </ng-container>
        </ul>
      </ng-container>

      <ng-container *ngIf="isDisplayPreOrderMealInformation">
        <div class="p-modal-menu02__title">
          <h2 class="p-modal-menu02__title-label" [innerHTML]="'label.preOrderMeal' | staticMsg"></h2>
          <ul class="c-inline-list01">
            <li class="c-inline-list01__item" [innerHTML]="'label.mealMenuDetail.preorder.c' | staticMsg"></li>
            <li class="c-inline-list01__item" [innerHTML]="'label.ruleDetail.meal.preorder.B' | staticMsg"></li>
          </ul>
        </div>
        <ul class="p-modal-menu02__list">
          <ng-container *ngFor="let displayedPreOrderMeal of displayedPreOrderMealList">
            <ng-container
              *ngIf="
                displayedPreOrderMeal.isActive && isDisplaySoldOut(displayedPreOrderMeal?.quota ?? 0) !== true;
                else inActivePreOrder
              "
            >
              <li class="p-modal-menu02__list-item">
                <!-- ※当該事前オーダーミール情報.code="WGML"の場合、非表示する。 -->
                <button
                  type="button"
                  class="p-modal-menu02__btn p-modal-menu02__btn--arrow"
                  id="pre-order-meal-active-{{ uuid }}"
                  (click)="handlePreMealMenu(displayedPreOrderMeal)"
                >
                  <span class="p-modal-menu02__btn-inner">
                    <span class="p-modal-menu02__btn-label" *ngIf="displayedPreOrderMeal.key">{{
                      displayedPreOrderMeal.key | staticMsg
                    }}</span>
                  </span>
                </button>
              </li>
            </ng-container>
            <ng-template #inActivePreOrder>
              <li class="p-modal-menu02__list-item">
                <!-- ※当該事前オーダーミール情報.code="WGML"の場合、非表示する。 -->
                <div class="p-modal-menu02__list-text">
                  <div class="p-modal-menu02__list-text-inner">
                    <span class="p-modal-menu02__btn-label" *ngIf="displayedPreOrderMeal.key">{{
                      displayedPreOrderMeal.key | staticMsg
                    }}</span>
                    <!-- 当該事前オーダーミール情報.quota=0の場合、売り切れである旨をラベルで表示する -->
                    <span
                      *ngIf="isDisplaySoldOut(displayedPreOrderMeal?.quota ?? 0)"
                      class="p-modal-menu02__btn-status"
                      [innerHTML]="'label.soldOut' | staticMsg"
                    >
                    </span>
                  </div>
                </div>
              </li>
            </ng-template>
          </ng-container>
        </ul>
      </ng-container>

      <div class="p-modal-menu02__title">
        <h2 class="p-modal-menu02__title-label" [innerHTML]="'label.specialMeal' | staticMsg"></h2>
        <ul class="c-inline-list01">
          <li class="c-inline-list01__item" [innerHTML]="'label.mealMenuDetail.special' | staticMsg"></li>
          <li class="c-inline-list01__item" [innerHTML]="'label.ruleDetail.meal.sub.special' | staticMsg"></li>
        </ul>
      </div>
      <ng-container *ngIf="displayedSpecialMealList && displayedSpecialMealList.length">
        <ng-container *ngFor="let specialMealGroup of displayedSpecialMealList">
          <!-- 当該カテゴリ別特別機内食情報の要素(以降、カテゴリ別特別機内食情報)数分繰り返し表示 -->
          <div class="p-modal-menu02__title-sub">
            <h3 class="p-modal-menu02__title-sub-label--em">{{ specialMealGroup.title }}</h3>
          </div>
          <ul class="p-modal-menu02__list">
            <ng-container *ngFor="let specialMeal of specialMealGroup.listSpecialMeal">
              <ng-container *ngIf="specialMeal.isActive; else inActiveSpecialMeal">
                <li class="p-modal-menu02__list-item">
                  <button
                    type="button"
                    class="p-modal-menu02__btn p-modal-menu02__btn--arrow"
                    id="allergen-free-meal-active-{{ uuid }}"
                    (click)="
                      onChangeSpecialMeal(
                        specialMeal?.type ?? '',
                        specialMeal?.code ?? '',
                        payload?.flightId!,
                        payload?.travelerId!
                      )
                    "
                  >
                    <span class="p-modal-menu02__btn-inner">
                      <span class="p-modal-menu02__btn-label">{{ specialMeal.mealName }}</span>
                    </span>
                  </button>
                </li>
              </ng-container>
              <ng-template #inActiveSpecialMeal>
                <li class="p-modal-menu02__list-item">
                  <div class="p-modal-menu02__list-text">
                    <div class="p-modal-menu02__list-text-inner">
                      <span class="p-modal-menu02__btn-label">{{ specialMeal.mealName }}</span>
                    </div>
                  </div>
                </li>
              </ng-template>
            </ng-container>
          </ul>
        </ng-container>
      </ng-container>

      <div class="p-modal-menu02__title">
        <h2 class="p-modal-menu02__title-label" [innerHTML]="'label.declineMeal' | staticMsg"></h2>
        <ul class="c-inline-list01">
          <li class="c-inline-list01__item" [innerHTML]="'label.ruleDetail' | staticMsg"></li>
        </ul>
      </div>
      <ul class="p-modal-menu02__list">
        <li class="p-modal-menu02__list-item">
          <button
            type="button"
            class="p-modal-menu02__btn p-modal-menu02__btn--arrow"
            id="decline-in-flight-meal"
            (click)="onRefuseInFlightMeal(flightId, travelerId)"
          >
            <span class="p-modal-menu02__btn-inner">
              <span class="p-modal-menu02__btn-label" [innerHTML]="'label.declineMealOption' | staticMsg"></span>
            </span>
          </button>
        </li>
      </ul>
    </div>
    <!-- //モーダルの中身が入ります -->
  </div>
</div>
